<template>
  <div v-if="device" class="device_profile">

    <div class="device_profile__left">

      <div class="line refer_info">
        <div v-if="device.version != null" class="version">
          <span v-for="(version, key) in device.version" :key="key">
            {{ version }}{{ key !== device.version.length -1 ? ',' : ''}}
          </span>
        </div>

        <div class="icons">
          <span
              class="mdi mdi-console-line icon"
              title="RPC Console"
              v-if="rpc_info.support_rpc && (this.$store.getters.getPermissions?.runDeviceRpc === true)"
              @click.prevent="show_rpc()"
          />

          <span
              class="mdi mdi-speedometer icon"
              :title="translate('run_test')"
              v-if="check_version() && (this.$store.getters.getPermissions?.runDeviceSelftest === true)"
              @click.prevent="creatingModalWindow"
          />

          <span
              v-if="this.$store.getters.getPermissions?.permissionSupport === true"
              class="mdi mdi-face-agent icon"
              :title="translate('support.contact')"
              @click.prevent="new_ticket()"
          />

          <span
              v-if="this.$store.getters.getPermissions?.permissionNotifications === true"
              class="mdi mdi-bell-ring-outline icon"
              :title="translate('notification.one')"
              @click.prevent="notification(device)"
          />
        </div>
      </div>

      <div class="line miniblocks">
        <div class="miniblock device_info card">
          <p>
            {{ device.device_model_info?.model_name }}
            <span
                class="mdi mdi-help-circle-outline"
                @mouseover="hide_app_info = false"
                @mouseleave="hide_app_info = true"
            />
          </p>
          <p>FW: {{ device.fw }}</p>
          <p @dblclick="copy(device.mid)">Mid: {{ device.mid}}</p>
          <p>
            Device ID:
            <b @dblclick="copy(device.id)">
              {{ device.id }}
            </b>
          </p>

          <div class="add_info card" :class="{ active: !hide_app_info }">
            <p>Manufacturer: {{ device.device_model_info?.manufacturer }}</p>
            <p>Description: {{ device.device_model_info?.descr }}</p>
          </div>

        </div>
        <div class="miniblock status_info card" :class="{ online: status, offline: !status, backup: device.backup, blocked: device.block_status?.status}">
          <div class="icons">
            <span class="icon mdi mdi-access-point-off offline" v-if="!status"/>
            <span class="icon mdi mdi-access-point online" v-if="status"/>
            <span class="icon mdi mdi-server-network backup" v-if="device.backup"/>
            <span class="icon mdi mdi-lock-alert blocked" v-if="device.block_status?.status"/>
          </div>

          <div class="text">
            <p>
              {{ !device.uptime ? '' : (status) ? translate('filter.status.online') : translate('filter.status.offline') }}
            </p>
            <p>
              {{ uptimeStr }}
            </p>
            <p>
              {{ last_date }}
            </p>
          </div>
          <div v-if="device.backup" class="backup">
            <p>
              IP: {{ device.backup?.ip }}
            </p>
            <p>
              Server: {{ device.backup?.server }}
            </p>
          </div>

        </div>
        <div
          class="miniblock temper card"
          :class="{pointer: this.$store.getters.getPermissions.viewDeviceStats}"
          v-if="device.device_status"
          :title="get_date(device.device_status.ts)"
          @click.prevent="go_to_stats()"
        >
          <p>
            <b>{{ translate('device.load') }}: </b>
            {{ device.device_status.cpu }} %
          </p>
          <p class="temper_param" v-if="device.device_status?.cpu_temp">
            <b>CPU:</b> {{ +((device.device_status?.cpu_temp > 1000) ? device.device_status?.cpu_temp/1000 : device.device_status?.cpu_temp) }}
            <span class="mdi mdi-temperature-celsius" />
          </p>
          <p class="temper_param">
            <b>board:</b> {{ (+device.device_status.mother_temp).toFixed(2) }}
            <span class="mdi mdi-temperature-celsius" />
          </p>
        </div>

        <div class="miniblock minimap card">

          <gmap-map
            v-if="minimap.show === true"
            :zoom="10"
            :center="minimap.coords"
            style="width: 100%; height: 100px"
          >
            <gmap-marker
              :position="minimap.coords"
              :icon="status ? { url: require('assets/icons/sistematics_online.png')} : { url: require('assets/icons/sistematics_offline.png')}"
              :draggable="false"
              @click="minimap.open = !minimap.open"
            />

            <gmap-info-window
                :options="{maxWidth: 300, pixelOffset: {width: 0, height: -20}, content: this.minimap.info, strokeColor:'#FF0000'}"
                :position="minimap.coords"
                :opened="minimap.open"
                @closeclick="minimap.open = false"
            >
            </gmap-info-window>

          </gmap-map>

          <div v-if="minimap.show === null" class="spinner_wrap">
            <scale-loader />
          </div>

          <div class="no_data" v-if="minimap.show === false">
            <p>{{ translate('no_data') }}</p>
          </div>
        </div>
      </div>

      <div class="line problems">
        <div class="blocked card" v-if="this.device.block_status?.status">
          <p>{{ translate('device.status') }} : {{ device.block_status.text_status }}</p>
          <p>{{ translate('device.reason') }} : {{ device.block_status.reason }}</p>
        </div>

      </div>

      <div class="line simcard_list" v-if="this.$store.getters.getPermissions?.viewDeviceSimcardList === true">
        <SimCardList
            :simcard_list="simcard_list"
        />
      </div>

      <div class="line servers" v-if="device.servers.length > 0">
        <div class="header_servers">
          <p class="title">{{ translate('server.list_of') }}</p>
        </div>
        <div class="form-group--wrap response_table">
          <table>
            <thead>
            <tr class="table_ip_tr">
              <th scope="col">
                {{ translate('server.one') }}
              </th>
              <th scope="col">
                {{ translate('server.port') }}
              </th>
              <th scope="col">
                IP
              </th>
              <th scope="col">
                Proxy Status
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(server,key) in device.servers"
                :key="key"
                class="table_ip_tr"
            >
              <td @dblclick="copy(server.ip)">
                {{ server.name }}({{ server.ip }})
              </td>
              <td @dblclick="copy(server.port)">
                {{ server.port }}
              </td>
              <td @dblclick="copy(server.device_ip)">
                {{ server.device_ip }}
              </td>
              <td @dblclick="copy(proxy_status(server.proxy))">
                {{ proxy_status(server.proxy) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="line main_info">
        <div class="header_main_info">
          <p class="title">{{ translate('device.main_info') }}</p>
        </div>

        <div class="card">
          <span class="mdi mdi-pen edit" v-if="this.$store.getters.getPermissions.editDeviceProfile" @click="editProfile()"/>

          <div class="card__left">
            <p>Name: {{ device.name2 }}</p>
            <p>Hidden Name: {{ device.name }}</p>
          </div>

          <div class="card__right">
            <router-link v-if="device.client" :to="{ path: '/clients/' + device.client?.client_id }">
              Client: {{ device.client?.client_name}}
            </router-link>

            <router-link :to="{ path: '/device_group/' + device.group_id }">
              Group: {{ this.$store.getters.getDeviceGroupById(device.group_id).name }}
            </router-link>
          </div>

          <p>Place: {{ device.place }}</p>
          <p>Place Full: {{ device.place_full }}</p>
          <p>Description: {{ device.desc }}</p>
          <p>Additional Description: {{ device.add_desc}}</p>
        </div>
      </div>

      <div class="line text-center">
        <span
          type="submit"
          style="margin-left: 20px;"
          class="btn btn-danger btn-wd"
          @click="blockedDevice()"
          v-if="this.device.block_status?.button_visible && (this.$store.getters.getPermissions.runDeviceBlock === true)"
        >
        {{ (!this.device.block_status?.status)? this.translate('block') : this.translate('unblock') }}
        </span>

      </div>
    </div>

    <div class="device_profile__right">
      <Summary
        type="device"
        :info="device"
      />
    </div>
  </div>
</template>
<script>
import EditProfileModal from './EditProfileModal'
import NewTicket from '../../General/Supports/NewTicket'
import Summary from '../../General/Summary.vue'
import RPCModal from './RPC/RPCModal'

import BlockDevice from "./BlockDevice";
import SimCardList from './SimcardList'
import NotificationEdit from "../../General/Notification/Notification/NotificationEdit";
import ModalWindowSpeedTest from "@/views/Dashboard/common/Device/Device/ModalWindowSpeedTest.vue";

export default {
  components: {
    SimCardList,
    Summary
  },

  props: {
    device: {
      type: [Array, Object],
      default: () => []
    },
    simcard_list: {
      type: [Array, Object],
      default: () => []
    },
  },

  data () {
    return {
      ch_group: false,
      showBlock: true,
      simcard_show: 'active',
      rpc_info: {},

      hide_app_info: true,
      uptimeStr: '0sec',
      timer_res: null,

      minimap:{
        open: false,
        coords:{
          lng: 0,
          lat: 0
        },
        source:"",
        info: "",
        show: null
      },
    }
  },

  created() {
    clearInterval(this.timer_res)
    this.uptimeToStr()
    this.timer_res = setInterval(this.uptimeToStr, this.$store.getters.getCountdown)

    this.get_minimap()

    if (this.$store.getters.getPermissions.runDeviceRpc === true) {
      this.get_rpc_info()
    }
  },


  computed: {
    fid() {
      return this.device.fid
    },
    opt_groups() {
      return this.$store.getters.getDeviceGroupsTree
    },
    status(){
      return this.device.uptime !== null ? this.device.uptime?.status : 0
    },
    last_date(){
      let timeUp = Math.round(Date.now() / 1000) - (this.device.uptime?.status_ts + 1)
      let days = Math.floor((timeUp / 86400))
      let str = ''
      if (days > 7){
        str += this.get_date(this.device.uptime.status_ts, {
          hour12: false,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })
      }
      return str
    }
  },

  watch : {
    device: {
      deep: true,
      handler () {
        this.change = !this.init
        this.$emit('change', this.change)
        this.init = false // первое изменение считаем инициализацией
        this.get_minimap()
      }
    },

    status () {
      clearInterval(this.timer_res)
      this.uptimeToStr()
      this.timer_res = setInterval(this.uptimeToStr, this.$store.getters.getCountdown)
    }
  },

  destroyed() {
    clearInterval(this.intervalSimDev)
    clearTimeout(this.timer_res)
  },

  methods: {
    go_to_stats(){
      if (this.$store.getters.getPermissions.viewDeviceStats){
        this.$router.push({
          path: '/device/' + this.$route.params.device_id + '/stats?temper=true',
        })
      }
    },
    uptimeToStr () {
      let str = ''

      if (this.device.uptime !== null) {
        let timeUp = Math.round(Date.now() / 1000) - (this.device.uptime?.status_ts + 1)

        let days = Math.floor((timeUp / 86400))
        str += (days > 0) ? days + ' ' + this.translate('date.d') + ' ': ''

        let hours = Math.floor((timeUp % 86400) / 3600)
        str += (hours > 0) ? hours + ' ' + this.translate('date.h') + ' ': ''

        let min = Math.floor((timeUp % 3600) / 60)
        str += min + ' ' + this.translate('date.min') + ' '

        if (!days){
          let sec = Math.floor((timeUp % 60))
          str += sec + ' ' + this.translate('date.sec') + ' '
        }
      }else{
        str += this.translate('device.off_forever')
      }

      this.uptimeStr = str
    },
    get_minimap(){
      this.$http.v1.getDeviceLocation(this.device.fid, (response) => {
        if (response.data.long === null) {
          this.minimap.show = false
          // this.global_notify('no-data', this.translate('no_data'))
        } else {
          this.minimap.show = true
          this.minimap.coords = {lat: +response.data.lat, lng: +response.data.long}
          this.minimap.source = response.data.source
          this.minimap.info = this.minimap.source + '<br/>' + this.minimap.coords.lat + ' ' + this.minimap.coords.lng
        }
      })
    },

    show_rpc(){
      this.$http.v1.getRPCInfo(this.device.fid, (response) => {
        var t = this.$createElement(RPCModal, {
          props: {
            history: response.data.cmd_history,
            list: response.data.cmd_list,
            fid: this.fid
          },
          on: {close: () => {this.$modal.hide('rpc_modal') }}
        })
        let temp = { render () { return t } }
        this.$modal.show(temp, {}, {width: 1100, height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'rpc_modal'})
      })
    },
    get_rpc_info(){
      this.$http.v1.getRPCInfo(this.device.fid, (response) => {
        this.rpc_info = response.data
      })
    },
    proxy_status(status){
      switch (status) {
        case null:
          return 'No Proxy';
        case 0:
          return 'Offline';
        case 1:
          return 'Online';
      }
    },
    new_ticket (val) {
      let t = this.$createElement(NewTicket, {props: {ticket: val, device_id: this.device.id}, on: {
        close: () => { this.$modal.hide('dynamic-modal') }
      }})
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    dblclk (ip) {
      if (navigator.clipboard !== undefined) {
        navigator.clipboard.writeText(ip)
        this.global_notify('info', this.translate('clipboard.value_save_buffer'))
      }
    },
    copy (item) {
      this.copy_to_clipboard(item)
      this.global_notify('info', this.translate('clipboard.value_save_buffer'))
    },

    editProfile () {
      let t = this.$createElement(EditProfileModal, {
        props: {
          device: this.device,
        },
        on: {
          close: () => {
            this.$modal.hide('edit_profile')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'edit_profile'})
    },

    blockedDevice(){
      let t = this.$createElement(BlockDevice, {
        props: {
          fid: this.fid,
          question: this.device.block_status?.status === 0 ? this.translate('device.ask_block') : this.translate('device.ask_unblock'),
          status: this.device.block_status?.status
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'dynamic-modal'})
    },

    check_group(parent, group, id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids){
      let new_group = {
        id: +group.id,
        expanded: false,
        hasExpanded: true,
        parent: group.parent,
        name: group.name,
        children: [],
        role: 'group'
      }
      if(groups_ids.indexOf(+group.id) > -1){
        new_group.checked = true
        new_group.children.push({ role: 'empty', visible: false, checked: true })
      }else{
        new_group.checked = false
        new_group.children.push({ role: 'empty', visible: false })
      }

      parent.children[id] = new_group

      if (groups_for_dev_ids.indexOf(parent.children[id].id) > -1 || groups_for_grp_ids.indexOf(parent.children[id].id) > -1) {
        parent.children[id].expanded = true
        this.$http.v1.getListDevicesByIdGroup({group_id: group.id}, (response) => {
          let devices = response.data
          for(let j in devices) {
            let device = {
              name: '(' + devices[j].fid + ') ' + '<b>' + devices[j].name2 + '</b>',
              id: devices[j].device_id,
              role: 'children',
              group_id: +group.id,
              fid: devices[j].fid
            }
            devs_ids.indexOf(+devices[j].device_id) > -1 ? device.checked = true : device.checked = false

            parent.children[id].children.push(device)
          }
        })
      }

      if (group.children) {
        for(let children_id in group.children) {
          this.check_group(parent.children[id], group.children[children_id], children_id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids);
        }
      }

    },

    notification (device) {
      let devs_ids = [device.id]
      let groups_for_dev_ids = [device.group_id]

      let notice_list = {}
      notice_list.devices = []
      groups_for_dev_ids = groups_for_dev_ids.concat(...this.$store.getters.getPathGroupById(device.group_id))

      notice_list.devices.push({
        name: '(' + device.fid + ') ' + '<b>' + device.name2 + '</b>',
        name2: device.name2,
        id: device.id,
        role: 'children',
        group_id: +device.group_id,
        checked: true,
        fid: device.fid
      })

      let groups = this.$store.getters.getDeviceGroupsTree

      let group_list = {children: []}
      for(let group_id in groups) {
        this.check_group(group_list, groups[group_id], group_id, devs_ids, groups_for_dev_ids, [], []);
      }

      var t = this.$createElement(NotificationEdit, {
        props: {
          notice: notice_list,
          list_devices: group_list.children,
          source: 'device'
        }, on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto',  width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },

    creatingModalWindow () {
      this.$http.v1.getDeviceStatus(this.device.fid, (response) => {
        if (response.data.uptime.status === 1) {
          let ifaces_by_slot = [{'label':'stcp', 'id':'stcp'}]
          for (let simcard in response.data.sim){
            if (response.data.sim[simcard].slot !== null){
              ifaces_by_slot.push({'label':'usb_' + response.data.sim[simcard].slot.toLowerCase(), 'id':'usb_' + response.data.sim[simcard].slot.toLowerCase()})
            }
          }
          let t = this.$createElement(ModalWindowSpeedTest, {
            props: {
              fid: this.device.fid,
              sim_list: ifaces_by_slot
            },
            on: {
              close: () => {this.$modal.hide('dynamic-modal') }
            }
          })
          let temp = {
            render () { return t }
          }
          this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
        } else {
          this.global_notify('info', this.translate('http.device_offline'))
        }
      })
    },

    check_version(){
      if (typeof(this.device?.fw) !== "string") {
        return false
      }
      let clear_version = this.device.fw.split('-')
      let version = '2.0.3'
      return this.versionCompare(clear_version[0], version) >= 0
    },

    versionCompare(left, right) {
      if (typeof left !== 'string' || typeof right !== 'string') {
        return false;
      }

      let a = left.split('.').map(Number);
      let b = right.split('.').map(Number);
      let len = Math.max(a.length, b.length);

      for (let i = 0; i < len; i++) {
        let numA = i < a.length ? a[i] : 0;
        let numB = i < b.length ? b[i] : 0;

        if (numA > numB) {
          return 1;
        } else if (numA < numB) {
          return -1;
        }
      }

      return 0;
    }

  }
}

</script>

<style lang='scss' scoped>
  .device_profile{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    overflow: auto;

    &__left{
      width: 65%;
      height: 100%;
      padding: 0 10px;

      .line {
        margin-bottom: 15px;
      }

      .refer_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;

        .version {
          font-size: 12px;
          color: #9A9A9A;
          width: calc(100% - 145px);
        }

        .icons{
          display: flex;
          .icon{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            font-size: 24px;
            border: 2px solid #66615b;
            border-radius: 5px;
            margin: 0 2px;
            cursor: pointer;
            transition: 0.15s;
            &:hover{
              border-color: #41B883;
              color: #41B883;
            }
          }
        }
      }
      .miniblocks{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .miniblock{
          width: 50%;
          height: 100px;
          margin: 0 5px;
          padding: 7.5px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          background-color: #fff;

          p{
            font-size: 14px;
            margin: 0;
          }

          &:first-child{
            margin-left: 0;
          }
          &:last-child{
            margin-right: 0;
          }

          &.device_info{
            position: relative;
            justify-content: space-between;

            .add_info{
              padding: 5px;
              opacity: 0;
              height: 0;
              position: absolute;
              bottom: 0;
              right: 0;
              width: 100%;
              transform: translateY(100px);
              transition: 0.2s;
              z-index: -1;
              &.active{
                opacity: 1;
                z-index: 1;
                height: auto;
                transform: translate(0px ,0px);
              }

            }
          }
          &.status_info{
            align-items: center;
            position: relative;

            &.online{
              border-color: #41B883;
              background-color: #41b88330;
              color: #41B883;
            }

            &.offline{
              background-color: #91919130;
              color: #919191;
            }

            &.blocked{
              border-color: #b84141;
              background-color: #b8414130;
              color: #b84141;
            }

            &.backup{
              border-color: #ffb058;
              background-color: #ffb05830;
              color: #d38d47;
              div{
                text-align: center;
              }
            }
            .icons{
              position: absolute;
              left: 0;
              top: 0;
              height: 100% ;
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              flex-direction: column;
              .icon{
                font-size: 22px;
                line-height: 100%;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                &.online{
                  font-size: 24px;
                  color: #41B883;
                }
                &.offline{
                  color: #919191;
                }
                &.blocked{
                  color: #b84141;
                }
                &.backup{
                  color: #d38d47;
                }
              }
            }

            .text{
              text-align: center;
            }
          }
          &.temper{
            justify-content: space-around;
            color: #333;
            .temper_param {
              display: inline-block;
            }
          }
          &.minimap{
            padding: 0;
            position: relative;
            .no_data{
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              right: 0;
              border-color: #919191;
              background-color: #91919130;
              color: #919191;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }

      .problems{
        .blocked{
          border-color: #b84141;
          background-color: #b8414130;
          color: #b84141;
          padding: 10px;
          p{
            font-size: 14px;
            line-height: 120%;
            margin: 0;
          }
        }
      }

      .simcard_list{
        .response_table{
          margin: 0;
        }
      }

      .servers{
        .header_servers{
          margin-bottom: 0;
          .title{
            font-size: 12px;
            line-height: 120%;
            font-weight: bold;
          }
        }
        .response_table{
          padding: 0;
          table{
            tr{
              background-color: white;
            }
          }
        }
      }

      .main_info{
        .header_main_info{
          margin-bottom: 0;
          .title{
            font-size: 12px;
            line-height: 120%;
            font-weight: bold;
          }
        }
        .card{
          padding: 10px 30px 10px 10px;
          background-color: #fff;
          position: relative;
          .edit{
            position: absolute;
            top: 5px;
            right: 5px;
            width: 20px;
            height: 20px;
            text-align: center;
            vertical-align: middle;
            font-size: 20px;
            color: #66615b;
            transition: 0.2s;
            cursor: pointer;
            &:hover{
              color: #41B883;
            }
          }
          &__left{
            display: inline-block;
            width: 50%;
          }
          &__right{
            display: inline-block;
            width: 50%;
            a{
              font-size: 14px;
              color: #41B883;
              display: block;
              margin-bottom: 5px;
              line-height: 1.4em;
              &:hover{
                color: #41B883CC;
              }
            }
          }
          p{
            font-size: 14px;
            margin-bottom: 5px;
          }
        }
      }

      .place{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .w40{
          width: 40%;
        }
        .w20{
          width: 20%;
          .btn-100{
            width: 100%;
          }
        }

        .form-group--wrap{
          margin: 0 5px;
          &:first-child{
            margin-left: 0;
          }
          &:last-child{
            margin-right: 0;
          }
          .form-group{
            margin: 0;
          }
        }
      }


    }

    &__right{
      width: 35%;
      height: 100%;
    }
  }

@media (max-width: 1200px) {
  .device_profile {
    flex-direction: column;

    &__left {
      width: 100%;
    }

    &__right {
      width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .device_profile {
    &__left {
      height: auto;
      .miniblocks {
        flex-wrap: wrap;

        .miniblock {
          width: 49.5%;
          margin: 2px 0;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .device_profile {
    &__left {
      .refer_info{
        .version{
          width: 60%;
        }
        .icons{
          width: 40%;
          flex-wrap: wrap;
          justify-content: flex-end;
          .icon{
            margin: 2px;
          }
        }
      }

      .miniblocks {
        .miniblock{
          width: 100%;
          p{
            font-size: 10px;
          }
        }
      }

      .main_info{
        .card{
          &__left{
            width: 100%;
          }
          &__right{
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
